// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1zVaY","notes":"Notes_notes__21ENX"};